import { Action } from 'redux';

import { COUNTS_DECREMENT, COUNTS_SET_COUNTS } from '../../constants/actionTypes';
import { TThunkAction } from '../../types/redux';

import { getUserFavoritesCount as getUserFavoritesCountApi } from '../../api/getUserFavoritesCount';
import { IFavoriteCountsSchema } from '../../repositories/favorites/entities/favorite_counts/FavoriteCountsSchema';
import { EEntityType, EDealType } from '../../types/filters';

export type TDecrementCount = 'counts/decrement';
export type TSetCounts = 'counts/set_user_favorites_count';

export interface IDecrementCount extends Action<TDecrementCount> {
  type: TDecrementCount;
  dealType: EDealType;
  entityType: EEntityType | null;
}

export interface ISetCounts extends Action<TSetCounts> {
  type: TSetCounts;
  data: IFavoriteCountsSchema;
}

export type TCountsActions = IDecrementCount | ISetCounts;

export function decrementCount(dealType: EDealType, entityType: EEntityType) {
  return {
    type: COUNTS_DECREMENT,
    dealType,
    entityType,
  };
}

export function getUserFavoritesCount(): TThunkAction {
  // tslint:disable-next-line:variable-name
  return (dispatch, _getState, context) => {
    return getUserFavoritesCountApi(context.httpApi)
      .then(response => {
        if (response.statusCode === 200) {
          dispatch<ISetCounts>({
            type: COUNTS_SET_COUNTS,
            data: response.response,
          });
        }
      })
      .catch(error => {
        context.logger.error(error);
      });
  };
}
